import type { IdentifiedChoiceResult } from '../types';

export const getIdentitiesWithNameFallback = (
  identities: IdentifiedChoiceResult[] | null,
) => {
  if (!identities) {
    return null;
  }
  return identities.map((identity) => ({
    choiceId: identity.choiceId,
    participants: getParticipantsWithNameFallback(identity.participants) ?? [],
  }));
};

export const getParticipantsWithNameFallback = (
  participants: IdentifiedChoiceResult['participants'] | undefined,
) => {
  if (!participants) {
    return null;
  }
  return participants.map((participant) => ({
    ...participant,
    displayName: participant.displayName || 'unknown',
  }));
};
